<template>
  <div>
    <v-row class="mt-8">
      <v-col>
        <h3>{{ $t('home.banner') }}</h3>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-btn color="warning" @click="triggerImageUpload">
          {{ $t('home.upload_new_banner') }}
          <input
            id="image_upload"
            type="file"
            style="display: none"
            accept="image/x-png, image/png,image/jpeg, image/pjpeg,image/gif"
            multiple
            @change="setBanner"
          />
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col col="12">
        <!-- <draggable
          :list="banner_file"
          group="people"
          @start="drag = true"
          @end="drag = false"
          class="d-flex overflow draggable_width"
        >
          <v-card
            v-for="data in banner_file"
            :key="data.id"
            class="d-flex flex-column align-center py-2 drag-cursor mx-2"
            width="225"
            outlined
          >
            <div class="d-flex justify-end" style="width: 100%">
              <v-btn icon color="error" @click="removeBanner(data.id)">
                <v-icon>{{ delete_icon }}</v-icon>
              </v-btn>
            </div>
            <v-img :src="data.image_path" width="200" height="200"></v-img>
          </v-card>
        </draggable> -->
        <draggable
          :list="home_data"
          group="people"
          @start="drag = true"
          @end="drag = false"
          class="draggable_width mt-5"
        >
          <v-card class="mb-8 px-4 py-2 drag-cursor" v-for="data in home_data" :key="data.id">
            <v-row>
              <v-col col="12" class="d-flex justify-end">
                <v-btn icon color="error" @click="removeBanner(data.id)">
                  <v-icon>{{ delete_icon }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="4" lg="5" md="5" sm="12" cols="12" class="d-flex align-center">
                <v-img :src="data.image_path"></v-img>
              </v-col>
              <v-col xl="8" lg="5" md="5" sm="12" cols="12">
                <HomeTab
                  :title="data.slogan_title"
                  :subtitle="data.slogan_subtitle"
                  :description="data.slogan_description"
                  :image_id="data.id"
                  v-on:getTitle="getTitle"
                  v-on:getSubTitle="getSubTitle"
                  v-on:getDescription="getDescription"
                />
              </v-col>
            </v-row>
          </v-card>
          <!-- <v-row v-for="data in home_data" :key="data.id">
            <v-col>
              <v-card class="d-flex flex-column align-center py-2 drag-cursor mx-2" width="225" outlined>
                <div class="d-flex justify-end" style="width: 100%">
                  <v-btn icon color="error" @click="removeBanner(data.id)">
                    <v-icon>{{ delete_icon }}</v-icon>
                  </v-btn>
                </div>
                <v-img :src="data.image_path" width="200" height="200"></v-img>
              </v-card>
            </v-col>
            <v-col>
              <HomeTab
                :title="data.slogan_title"
                :subtitle="data.slogan_subtitle"
                :description="data.slogan_description"
                v-on:getTitle="getTitle"
                v-on:getSubTitle="getSubTitle"
                v-on:getDescription="getDescription"
              />
            </v-col>
          </v-row> -->
        </draggable>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn color="success" depressed @click="updateHome" :loading="loading">
          {{ $t('general.save') }}
        </v-btn>
      </v-col>
    </v-row>
    <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
  </div>
</template>

<script>
import { mdiCamera, mdiDelete } from '@mdi/js'
import { getData, postData } from '@/api'
import { MEDIA_PATH, DEFAULT_IMAGE_PATH } from '@/global'
import SnackBar from '@/components/SnackBar'
import HomeTab from '@/components/HomeTab'
import { globalFunc } from '@/global'
import draggable from 'vuedraggable'

export default {
  name: 'Home',
  mixins: [globalFunc, MEDIA_PATH, DEFAULT_IMAGE_PATH],
  components: { SnackBar, HomeTab, draggable },
  data: () => ({
    camera_icon: mdiCamera,
    delete_icon: mdiDelete,
    img_path: MEDIA_PATH,
    snack_bar_text: '',
    snack_bar_open: false,
    banner_file: [],
    loading: false,
    image_id: 0,

    // home_data: {
    //   slogan_title: {
    //     zh: '',
    //     en: '',
    //     cn: '',
    //   },
    //   slogan_subtitle: {
    //     zh: '',
    //     en: '',
    //     cn: '',
    //   },
    //   slogan_description: {
    //     zh: '',
    //     en: '',
    //     cn: '',
    //   },
    //   banner_images: [],
    // },
    home_data: [],
    original_home_data: [],
  }),
  created() {
    this.initializeHome()
  },
  methods: {
    async initializeHome() {
      try {
        let params = new URLSearchParams()

        params.set(
          'get_all_data_by_data_type',
          JSON.stringify({
            data_type: 'home_data',
          }),
        )

        let result = await getData(params)
        globalFunc.log(result)

        if (Array.isArray(result)) {
          this.home_data = []
        } else {
          let temp = []

          let largest_key = -1

          Object.assign(this.original_home_data, result.item_list)

          for (let i = 0; i < result.item_list.length; i++) {
            result.item_list[i]['upload_file'] = []
            result.item_list[i]['image_path'] =
              result.item_list[i].banner_images.length == 0 ? '' : MEDIA_PATH + result.item_list[i].banner_images[0]
            temp.push(result.item_list[i])
            if (largest_key < result.item_list[i].id) {
              largest_key = result.item_list[i].id
            }
          }

          if (largest_key == -1) {
            this.image_id = 1
          } else {
            this.image_id = largest_key + 1
          }

          temp.sort((a, b) => {
            return a.photo_order - b.photo_order
          })

          this.home_data = temp
        }
      } catch (error) {
        globalFunc.log(error)
      }
    },
    async updateHome() {
      if (!this.loading) {
        this.loading = true
        try {
          for (let i = 0; i < this.home_data.length; i++) {
            this.home_data[i]['photo_order'] = i + 1
          }

          for (let i = 0; i < this.home_data.length; i++) {
            if (this.home_data[i].upload_file.length != 0) {
              let base64Path = await globalFunc.firstFileToBase64(this.home_data[i].upload_file[0])
              let type = this.home_data[i].upload_file[0].type.substring(
                this.home_data[i].upload_file[0].type.lastIndexOf('/') + 1,
              )
              let params = new URLSearchParams()
              params.set(
                'upload_file',
                JSON.stringify({
                  upload_data: base64Path,
                  upload_file_type: type,
                }),
              )
              let upload_file = await postData(params)
              this.home_data[i].banner_images = upload_file

              params = new URLSearchParams()

              let send_data = {
                banner_images: [this.home_data[i].banner_images],
                slogan_title: this.home_data[i].slogan_title,
                slogan_subtitle: this.home_data[i].slogan_subtitle,
                slogan_description: this.home_data[i].slogan_description,
                photo_order: this.home_data[i].photo_order,
              }

              params.set('add_home', JSON.stringify(send_data))
              let result = await postData(params)
              globalFunc.log('add')
              globalFunc.log(result)

              this.snack_bar_text = this.$t('instruction.create_success')
            } else {
              let params = new URLSearchParams()

              params.set(
                'update_home',
                JSON.stringify({
                  id: this.home_data[i].id,
                  banner_images: this.home_data[i].banner_images,
                  slogan_title: this.home_data[i].slogan_title,
                  slogan_subtitle: this.home_data[i].slogan_subtitle,
                  slogan_description: this.home_data[i].slogan_description,
                  photo_order: this.home_data[i].photo_order,
                }),
              )

              let result = await postData(params)

              globalFunc.log('update')
              globalFunc.log(result)

              this.snack_bar_text = this.$t('instruction.update_success')
            }
          }

          this.snack_bar_open = true
          setTimeout(() => {
            location.reload()
          }, 2000)
        } catch (error) {
          if (globalFunc.DataValid(this.home_data.id)) {
            this.snack_bar_text = this.$t('instruction.update_fail')
          } else {
            this.snack_bar_text = this.$t('instruction.create_fail')
          }

          this.loading = false
          this.snack_bar_open = true
          globalFunc.log(error)
        }
      }

      // TODO: REMOVE THE ID FOR NEW PHOTO
    },
    triggerImageUpload() {
      document.getElementById('image_upload').click()
    },
    setBanner(event) {
      let file = event.target.files
      if (globalFunc.DataValid(file) && file.length > 0) {
        let data = {
          slogan_title: {
            zh: '',
            en: '',
            cn: '',
          },
          slogan_subtitle: {
            zh: '',
            en: '',
            cn: '',
          },
          slogan_description: {
            zh: '',
            en: '',
            cn: '',
          },
          upload_file: file,
        }
        data['id'] = this.image_id

        this.image_id++
        data['image_path'] = URL.createObjectURL(file[0])

        this.home_data.push(data)
      }
    },
    async removeBanner(id) {
      if (!this.loading) {
        this.loading = true

        let index = this.getPhotoIndex(id)
        if (index != -1) {
          if (this.home_data[index].upload_file.length == 0) {
            try {
              let params = new URLSearchParams()
              params.set(
                'delete_data_by_data_type_and_id',
                JSON.stringify({
                  id: id,
                  data_type: 'home_data',
                }),
              )
              let remove_file = await postData(params)
              this.home_data.splice(index, 1)
            } catch (error) {
              globalFunc.log(errror)
            }
          } else {
            this.home_data.splice(index, 1)
          }
        }

        this.loading = false
      }
    },
    getPhotoIndex(id) {
      let index = -1
      index = this.home_data.findIndex(obj => {
        return obj.id == id
      })

      return index
    },
    getTitle(title, type, id) {
      let index = this.getPhotoIndex(id)
      if (index != -1) {
        this.home_data[index].slogan_title[type] = title
      }
    },
    getSubTitle(subtitle, type, id) {
      let index = this.getPhotoIndex(id)
      if (index != -1) {
        this.home_data[index].slogan_subtitle[type] = subtitle
      }
    },
    getDescription(description, type, id) {
      let index = this.getPhotoIndex(id)
      if (index != -1) {
        this.home_data[index].slogan_description[type] = description
      }
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
}
</script>

<style scoped>
.draggable_width {
  width: 100%;
}

.overflow {
  overflow-x: auto;
}

.drag-cursor:hover {
  cursor: move;
}
</style>
